

export const Paths = {
  Dashboard: "/dashboard",
  DashboardUDC: "/UDC/dashboard",
  LogIn: "/login",
  EntrepreneurAdminLogin: "/admin/login",
  EntrepreneurAdminAssessmentUsers: "/admin/assessment-users",
  EntrepreneurAdminAssessmentDetail: "/admin/assessment-details",
  EntrepreneurAdminReport: "/admin/report",
  EntrepreneurAdminSettings: "/admin/settings",
  EntrepreneurAdminQuestionAnswer: "/admin/questions-answers",
  EntrepreneurAdminAccessCodes: "/admin/access-codes",
  EntrepreneurAdminMasterAccessCodes: "/admin/master-access-codes",
  EntrepreneurAdminMasterAccessCodeSingle: "/admin/master-access-code",
  EntrepreneurAdminContacts: "/admin/contact-us-queries",
  EntrepreneurAdminAccessRequests: "/admin/access-requests",
  SignUp: "/register",
  ForgotPassword: "/forgot-password",
  QuestListFirst: "/user-question/:id",
  ResetPassword: "/api/v1/users/password",
  MyAssessments: "/my-assessments",
  Certificate: "/certificates",
  LearningProgram: "/learning-programs",
  Messages: "/messages",
  Profile: "/profile",
  Home: "/",
  About: "/about",
  CompleteSignup: "/complete-signup",
  Admin: "/admin",
  GetUserInfo: "/get-user-info",
  UpdateUserProfile: "/updateuserprofile",
  Completed: "/completed",
  Instructions: '/instructions',
  Welcome: "/welcome",
  AdminReporting: "/reporting",
  StudentAssessment: "/web-assessment",
  UdcStudentAssessment: "/udc-web-assessment",
  UdcAssessementCompleted: "/completed",
  udcWelcome: "/udc-welcome",

  assessmentDashboardGames: '/assessment-dashboard/games/:game_name',

  upgradeDashboard: '/upgrade-dashboard',
  upgradeGamesSurvey: '/games-survey',
  upgradeSchedule: '/schedule',
  upgradeReports: '/reports',
  upgradeAdvisorsCourses: '/advisors-courses',
  UpgradeSettings: '/settings',
  UpgradeDemographics: '/demographics',
  upgradeIntroduction: '/survey-introduction',
  upgradeSurveyQuestions: '/survey-questions',
  upgradeDemographicsQuestions: '/demographics-question',
  UpgradeFeedbackQuestions: '/feedback-questions',
  UpgradeContactUs: '/contact-us',
  GenericDashBoard: '/generic-dashboard',
  GenericGamesAndSurvey: '/generic-games-survey',
  GenericSchedule: '/generic-schedule',
  GenericReports: '/generic-reports',
  GenericAdvisorsCourses: '/generic-advisorsCourses',
  GenericSetting: '/generic-settings',
  GenericDemographics: '/generic-demographics',
  GenericIntroduction: '/generic-introduction',
  GenericQuestionnaire: '/generic-questionnaire',
  GenericFeedback: '/generic-feedback',
  GenericContactUs: '/generic-contact-us',
  GenericDemographicsQueslist: '/generic-demographic-questionnaire',
  GenericAllGames: '/generic-games-tab',
  GenericGamesStatusPage: '/generic-games-reports',
  EL_Introduction: "/entrepreneurial-leadership/introduction",
  EL_LANDING: "/entrepreneur",
  EntrepreneurContactUs: "/entrepreneur/contact-us",
  CreightonContactUs: "/creighton/contact-us",
  ProlificBonusSubmission: "/prolific-bonus-submission"
};
